<div class="{{ cssStyle }}">
  <div class="left">
    <ng-content select="[left]"></ng-content>
  </div>
  <h4
    [ngClass]="{ 'pill-mod': canShowExtension && (priceSubject$ | async) }"
    (click)="extendHeader()"
    id="modal-title"
    class="title"
    >{{ title }}
    @if (canShowExtension && (priceSubject$ | async)) {
      <svg-inline
        src="/assets/images/extendable-icon.svg"
        alt="image-icon" />
    }
  </h4>
  @if (canShowExtension && (priceSubject$ | async)) {
    @if ({ val: isMaxOrdersReached$ | async }; as isLimitReached) {
      @if (showInfoText) {
        <div class="info-text info-text-bottom">
          <span>{{ "limit_order_info_popup" | translate }}</span>
          <img
            (click)="dismissTooltip()"
            class="dismiss-icon"
            src="/assets/images/dismiss-shape.svg"
            alt="image-icon" />
        </div>
      }
      @if (showExtendOptions) {
        <div class="extend-options-list">
          @for (option of extendOptions; track option) {
            <button
              [disabled]="!option.available"
              (click)="selectOption(option, isLimitReached.val)"
              [class.selected]="option.value === selected?.value"
              class="extend-option-item">
              <img [src]="option.icon" alt="image-icon" />
              <div class="flex flex-col text-container">
                <div class="title-container">
                  <span class="header">{{ option.label | translate }}</span>
                  @if (option.value === 'price_order' && showNewText) {
                    <span class="new-label">{{
                      "new_label" | translate
                    }}</span>
                  }
                </div>
                @if(!option.available) {
                  <span class="sub-header">
                    {{ "price_order_buy_description_disabled_option" | translate }}</span
                    >
                  } @else {
                    <span class="sub-header"> {{ option.subtext | translate }}</span>
                  }
                </div>
                <div class="checkmark-container">
                  @if (option.value === selected?.value) {
                    <svg-inline
                      src="/assets/images/extend-option-checkmark-icon.svg"
                      alt="image-icon" />
                  }
                </div>
              </button>
            }
          </div>
        }
      }
    }
    <div class="right">
      <ng-content select="[right]"></ng-content>
    </div>
    @if (showIndicator && step) {
      <span class="indicator">{{ step }}</span>
    }
  </div>
